module.exports = __webpack_public_path__ + "static/media/user_icon_private_red.210d5b48.svg";